module.exports = __webpack_public_path__ + "static/media/YM46_1.01cee778.jpg";